module.exports = __webpack_public_path__ + "static/turtle-creek-house50-f446ce5107f6db58b4ab56d1650d8eb7.jpg";